import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';;
import {AudioTranscriptionModel} from '../audioTranscription.model';
import {AudioRecordSummaryConverter} from '../../../../record/api/model/converter/audioRecordSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class AudioTranscriptionConverter extends HttpModelConverter<AudioTranscriptionModel> {

    constructor(private audioRecordSummaryConverter: AudioRecordSummaryConverter) {
        super();
    }
    protected createInstance(): AudioTranscriptionModel {
        return new AudioTranscriptionModel();
    }

    protected enrichObject(result: AudioTranscriptionModel, src: AudioTranscriptionModel) {
        result.audioRecord = this.audioRecordSummaryConverter.convert(src.audioRecord);
    }
}
